import React, { useState,useEffect } from "react";
import { toast } from 'react-toastify';
import ColorPicker from "../../../components/ColorPicker";
import CssCodeEditor from "../../../components/CssCodeEditor";
import JsCodeEditor from "../../../components/JsCodeEditor";

const AppearanceTab = ({ updatePdfEmbedTabData,pdfEmbedTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [widgetTitleColor, setWidgetTitleColor] = useState(pdfEmbedTabData.widget_title_color);
    const [nameColor, setNameColor] = useState(pdfEmbedTabData.name_color);
    const [iconColor, setIconColor] = useState(pdfEmbedTabData.icon_color);
    const [downloadlinkColor, setDownloadlinkColor] = useState(pdfEmbedTabData.download_link_color);
    const [backgroundColor, setBackgroundColor] = useState(pdfEmbedTabData.background_color);
    const [fileBackgroundColor, setFileBackgroundColor] = useState(pdfEmbedTabData.file_background_color);
    const [nameSize, setNameSize] = useState(pdfEmbedTabData.name_size);
    const [nameSizeDropdownOpen, setNameSizeDropdownOpen] = useState(false);
    const [downloadSize, setDownloadSize] = useState(pdfEmbedTabData.download_size);
    const [downloadSizeDropdownOpen, setDownloadSizeDropdownOpen] = useState(false);
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(pdfEmbedTabData.custom_css);
    const [jsTabCustomJs, setJsTabCustomJs] = useState(pdfEmbedTabData.custom_js);
    
    // Handlers Widget Title Color Change
    const handleWidgetTitleColorChange = (color) => {
        setWidgetTitleColor(color.hex);
        updatePdfEmbedTabData("widget_title_color", color.hex);
    };

    // Handlers Name Color Change
    const handleNameColorChange = (color) => {
        setNameColor(color.hex);
        updatePdfEmbedTabData("name_color", color.hex);
    };

    // Handlers Icon Color Change
    const handleIconColorChange = (color) => {
        setIconColor(color.hex);
        updatePdfEmbedTabData("icon_color", color.hex);
    };

    // Handlers Download link Color Change
    const handleDownloadlinkColorChange = (color) => {
        setDownloadlinkColor(color.hex);
        updatePdfEmbedTabData("download_link_color", color.hex);
    };

    // Handlers Background Color Change
    const handleBackgroundColorChange = (color) => {
        setBackgroundColor(color.hex);
        updatePdfEmbedTabData("background_color", color.hex);
    };

    // Handlers File Background Color Change
    const handleFileBackgroundColorChange = (color) => {
        setFileBackgroundColor(color.hex);
        updatePdfEmbedTabData("file_background_color", color.hex);
    };

    // Handlers Name Size Change
    const handleNameSizeChange = (font) => {
        setNameSize(font);
        updatePdfEmbedTabData("name_size", font);
        setNameSizeDropdownOpen(false);
    };

    // Handlers Download Size Change
    const handleDownloadSizeChange = (font) => {
        setDownloadSize(font);
        updatePdfEmbedTabData("download_size", font);
        setDownloadSizeDropdownOpen(false);
    };

    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updatePdfEmbedTabData("custom_css", code);
    };

    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);
    
    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updatePdfEmbedTabData("custom_js", code);
    }; 

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => { 
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };

    return (
         <div className="side-baar-inner-setting">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Appearance</span>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("colors")}>Colors <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("fonts")}>Fonts <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div> 
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_css")}>Custom Css <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_js")}>Custom JS <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div> 
                </>
            )}

            {activeSettingElementsTab === "colors" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Colors</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Widget Title</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={widgetTitleColor} setColor={setWidgetTitleColor} onChangeComplete={handleWidgetTitleColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Name</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={nameColor} setColor={setNameColor} onChangeComplete={handleNameColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Icon</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={iconColor} setColor={setIconColor} onChangeComplete={handleIconColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Download link</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={downloadlinkColor} setColor={setDownloadlinkColor} onChangeComplete={handleDownloadlinkColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Background</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={backgroundColor} setColor={setBackgroundColor} onChangeComplete={handleBackgroundColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>File Background</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={fileBackgroundColor} setColor={setFileBackgroundColor} onChangeComplete={handleFileBackgroundColorChange}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )} 

            {activeSettingElementsTab === "fonts" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Fonts</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Name</span>
                                <div className="color-pikr-box" onClick={() => setNameSizeDropdownOpen(!nameSizeDropdownOpen)}>
                                    <em>{nameSize}</em>
                                    {nameSizeDropdownOpen && (
                                        <ul className="dropdown-list">
                                            {["10px","11px","12px","13px","14px","15px","16px","17px","18px","19px","20px","22px","24px","26px","28px","30px","30px","34px","36px","40px","44px","48px","50px"].map((font) => (
                                                <li key={font} onClick={() => handleNameSizeChange(font)}>
                                                    {font}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>

                            <div className="box-header-row">
                                <span>Download</span>
                                <div className="color-pikr-box" onClick={() => setDownloadSizeDropdownOpen(!downloadSizeDropdownOpen)}>
                                    <em>{downloadSize}</em>
                                    {downloadSizeDropdownOpen && (
                                        <ul className="dropdown-list">
                                            {["10px","11px","12px","13px","14px","15px","16px","17px","18px","19px","20px","22px","24px","26px","28px","30px","30px","34px","36px","40px","44px","48px","50px"].map((font) => (
                                                <li key={font} onClick={() => handleDownloadSizeChange(font)}>
                                                    {font}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )} 

            {activeSettingElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )} 

            {activeSettingElementsTab === "custom_js" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom Js</span>
                        <div className="css-text height-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <div className="save-css-js"><button className="save-css-js" onClick={handleValidateClick}>Validate</button></div>
                        </div>
                    </div>
                </>
            )}

        </div>
    );
};

export default AppearanceTab;